import { Button } from "@/components/ui/button";
import { Check, Loader2, Plus } from "lucide-react";

interface FormActionsProps {
  isSubmitting: boolean;
  isEditing: boolean;
}

export const FormActions = ({ isSubmitting, isEditing }: FormActionsProps) => {
  return (
    <div className="flex justify-end">
      <Button 
        type="submit" 
        className="gap-2 min-w-[120px]"
        disabled={isSubmitting}
      >
        {isSubmitting ? (
          <>
            <Loader2 className="w-4 h-4 animate-spin" />
            جاري الحفظ...
          </>
        ) : isEditing ? (
          <>
            <Check className="w-4 h-4" />
            تحديث الأداة
          </>
        ) : (
          <>
            <Plus className="w-4 h-4" />
            إضافة الأداة
          </>
        )}
      </Button>
    </div>
  );
};